import { styled } from "@mui/material";

export const ContainerSyled = styled("div")(() => ({
  width: "100%",
  margin: 0,
  padding: "8px 40px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "8px",
  borderBottom: "1px solid #CBCBCB",
  background: "#EDEDED",
  color: "#0F110C",
  position: "fixed",
  top: "0",
  left: "0",
  zIndex: 100,
}));

export const ContainerLeftMenuStyled = styled("div")(
  ({ isMobile, isMenuOpen }) => ({
    color: "#0F110C",
    backgroundColor: isMobile ? "rgba(237, 237, 237, 0.8)" : "#EDEDED",
    borderRight: "1px solid #CBCBCB",
    minHeight: "100vh",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: 1000,
    padding: isMobile ? "8px 12px" : "16px 24px",
    width: isMobile ? "100%" : "fit-content",
    marginTop: isMobile ? "56px" : 0,
    display: isMenuOpen && isMobile ? "none" : "block",
  })
);

export const ContainerLinksStyled = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  margin: "24px 0",
}));

export const ContainerMenuStyled = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  backgroundColor: "#F7F7F7",
  borderRadius: "8px",
  boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
  zIndex: 1000,
  right: "0px",
  top: "44px",
}));
